
export interface MockStruct {
  [key : string] : any
}

export const mockApis : MockStruct = {}
